<template>
  <div>
    <Toast 
      id="toast"
    />

    <Toolbar class="p-mb-4">
      <template slot="left">
        <Button
          icon="pi pi-fw pi-cog"
          class="p-mr-1"
          @click="openColumnsSelection()"
        />
        <InputText
          v-model="searchText"
          placeholder="Global Search"
          @input="updateSearch"
        />
        <Button
          icon="pi pi-times p-pr-1"
          class="p-mr-1"
          @click="closeSearch"
        />
      </template>
      <template slot="right">
        <Button
          label="New Activity"
          icon="pi pi-plus"
          class="p-button-success p-mr-2"
          style="margin-right: 1em"
          @click="openNew"
        />
      </template>
    </Toolbar>

    <ActivityDataTable
      :dbView="dbView"
      :colSelectedFieldsForTable="colSelectedFieldsForTable"
      :activities="activities1"
      :dbViewFields="dbViewFields"
      :colSelectedFields="colSelectedFields"
      :loading="loading"
      @confirmDeleteActivity="confirmDeleteActivity"
      @editActivity="editActivity"
      @reload="reload"
      @reloadCols="reloadCols" 
    />
    
    <!-- Activity Form -->
    
    <ActivityForm
      v-if="activityDialog"
      :key="activityFormKey"
      :activityForm="activityDialog"
      mode="auto"
      :activityToEdit="activity"
      :disabledArr="disabledArr"
      @close="close"
      @saved="savedActivity"
    />  

    <ColumnSelection
      :columnSelectionDialog="columnSelectionDialog"
      :dbView="dbView"
      :dbViewFields="dbViewFields"
      :selectionToEdit="colSelectedFields"
      :reloadComponent="reloadColumnSelectionComponent"
      :resettingColumns="resettingColumns"
      @close="columnSelectionDialog = false"
      @colSaved="colSaved()"
      @resetCols="resetCols"
    />

  </div>
</template>

<script>
import moment from "moment";

import ActivityService from "@/service/ActivityService";
import CustomerService from "@/service/CustomerService";
import UserService from "@/service/UserService";
import QuotationService from "@/service/QuotationService";
import FiltersService from "@/service/FiltersSerice";

import ActivityDataTable from "@/mbp/universalComponents/activity/ActivitiesDataTable";
import ActivityForm from "@/mbp/universalComponents/activity/ActivityForm.vue";
import ColumnSelection from '@/mbp/universalComponents/columnSelection/ColumnSelection'

export default {
  props: ["opportunity"],
  components: {
    ActivityDataTable,
    ActivityForm,
    ColumnSelection
  },
  data: () => ({
    dbView: 5,
    activity: {},
    activityDialog: false,
    activities: null,
    activities1: null,
    disabledArr: [],
    activityFormKey1: 0,
    colSelectedFieldsForTable: [],
    dbViewFields: [],
    columnSelectionDialog: false,
    colSelectedFields: [],
    defaultView: true, // Not used
    searchText: '',
    requesting: false,
    reloadColumnSelectionComponent: 0,
    resettingColumns: false,
  }),
  computed: {
    loading() {
      if (this.activities1 && this.activities1[0]) {
        return false
      } else {
        if (this.requesting) {
          return true
        } else {
          return false
        }
      }
    },
    activityFormKey: {
      set(val) {
        this.activityFormKey1++
      },
      get() {
        return 'activityForm' + this.activityFormKey1.toString()
      }
    }
  },
  watch: {
    colSelectedFields(val) {
      this.$store.dispatch(`commons/columnsSelection${this.dbView}`, val)
      this.setupColumns()
    },
    activities(val) {
      
      if (val && val.length > 0 && !this.$route.query.search ) {
        this.activities1 = val
      } else {
        this.setupSearch(this.$route.query.search)
      }
    },
    dbViewFields(val) { // toggles between default view and user saved view
      
      if (this.colSelectedFieldsForTable.length < 1) {
        this.colSelectedFieldsForTable = val.filter(a => a.defView)
      }
      // this.colSelectedFieldsForTable.forEach(a => 
    },
    activityDialog(val) {
      this.activityFormKey++
    }
  },
  customerService: null,
  userService: null,
  quotationService: null,
  activityService: null,
  filtersService: null,
  created() {
    

    this.activityService = new ActivityService();
    this.customerService = new CustomerService();
    this.userService = new UserService();
    this.quotationService = new QuotationService();
    this.filtersService = new FiltersService();
  },
  mounted() {
    this.getAllActivitiesOppotunity(this.opportunity.oppId)

    if (this.$route.query.search) {
      this.searchText = this.$route.query.search
      this.setupSearch(this.$route.query.search)
    }

    document.getElementById('toast').addEventListener('click', () => this.toastClicked())

    this.getColumnSelection()
    this.getDBViewFields()
  },
  methods: {
    resetCols() {
      this.resettingColumns = true

      this.filtersService
        .resetColumns(this.dbView)
        .then(data => {
          this.resettingColumns = false
          this.columnSelectionDialog = false
          this.colSelectedFields = data
          this.getDBViewFields()
        })
        .catch(error => {
          this.resettingColumns = false
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: `Error while reseting columns`,
            life: 5000,
          })
        })
    },
    reloadCols() {
      this.getColumnSelectionByHard()
      this.getDBViewFields()
    },
    closeSearch() {
      this.searchText = ''
      this.$router.push({ query: { search: '' } });
      this.activities1 = this.activities
    },
    setupSearch(e) {
      
      if (e) {
        this.activities1 = this.activities

        // Do search here after having the EP

      } else {
        this.activities1 = this.activities
      }
    },
    updateSearch(e) {
      this.$router.push({ query: { search: e } });
      this.setupSearch(this.searchText)
    },
    colSaved() {
      
      this.columnSelectionDialog = false

      this.getColumnSelectionByHard()
      this.getDBViewFields()
    },
    openColumnsSelection() {
      this.columnSelectionDialog = true
      this.reloadColumnSelectionComponent++
    },
    setupColumns() {
      if (this.colSelectedFields && this.colSelectedFields[0] && this.columnSelectionDialog) {
        this.reloadColumnSelectionComponent++
      }

      let a = []
      this.colSelectedFields.forEach(b => {
        // 
        let c = a.find(d => d.dbField === b.dbField.dbField)
        // 
        if (!a[b.colOrder - 1] && !c) {
          a[b.colOrder - 1] = { 
            ...b.dbField,
            defWidth: b.width
          }
        }
      })
      
      if (a.length) {
        this.colSelectedFieldsForTable = a
      }
    },
    getColumnSelectionByHard() {
      this.filtersService
        .getColumnSelectionByHard(this.dbView)
        .then(data => {
          
          this.colSelectedFields = data
        })
        .catch(err => {
          

          if (err.response.status === 500) {
            // Default view
            
            this.defaultView = true
          }
                
          // this.$toast.add({
          //   severity: "error",
          //   summary: "Error",
          //   detail: "Error while column selection",
          //   life: 5000,
          // })
          this.$store.dispatch('addErrorMessage', {
            severity: 'error',
            content: 'Some data was not loaded from "currentUserViewFields/{dbView}"'
          })
        })
    },
    getColumnSelection() {
      this.filtersService
        .getColumnSelection(this.dbView)
        .then(data => {
          
          this.colSelectedFields = data
        })
        .catch(err => {
          

          if (err.response.status === 500) {
            // Default view
            
            this.defaultView = true
          }
                
          // this.$toast.add({
          //   severity: "error",
          //   summary: "Error",
          //   detail: "Error while column selection",
          //   life: 5000,
          // })
          this.$store.dispatch('addErrorMessage', {
            severity: 'error',
            content: 'Some data was not loaded from "currentUserViewFields/{dbView}"'
          })
        })
    },
    getDBViewFields() {
      this.filtersService
        .getDBViewFields(this.dbView)
        .then(data => {
          this.dbViewFields = []
          
          
          data.forEach((d, index) => {
            // 
            this.dbViewFields.push(d)
          })
          
        })
        .catch(err => {
          
                
          // this.$toast.add({
          //   severity: "error",
          //   summary: "Error",
          //   detail: "Error while getting customer DB view fields",
          //   life: 5000,
          // })
          this.$store.dispatch('addErrorMessage', {
            severity: 'error',
            content: 'Some data was not loaded from "dbViewFields/{dbView}"'
          })
        })
    },
    toastClicked() {
      
    },
    getAllActivitiesOppotunity(oppId) {
      if (oppId) {
        this.requesting = true
        this.activityService
          .getAllActivitiesOppotunity(oppId)
          .then(data => {
            this.requesting = false
            this.activities = data
          })
          .catch(err => {
            this.requesting = false
            
                  
            // this.$toast.add({
            //   severity: "error",
            //   summary: "Error",
            //   detail: "Error while getting activities",
            //   life: 5000,
            // })
            this.$store.dispatch('addErrorMessage', {
              severity: 'error',
              content: 'Some data was not loaded from "opportunityactivities/{oppId}"'
            })
          })
      }
    },
    reload() {
      this.getAllActivitiesOppotunity(this.opportunity.oppId)
    },
    savedActivity(activity) {
      
      this.getAllActivitiesOppotunity(this.opportunity.oppId)
      this.activityDialog = false
    },
    close() {
      this.activityDialog = false
    },
    editActivity(activity) {
      this.disabledArr = []
      this.activity = { ...activity };
      this.disabledArr = [
        'customer',
        'mbpBranch'
      ]
      this.activityDialog = true;
    },
    confirmDeleteActivity(activity) {
      this.activity = activity;
      
      if (activity && activity.activityId) {
        this.activityService
          .deleteActivity(activity.activityId)
          .then(() => {
            this.reload()
          })
          .catch(error => {
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: `The Activity was not deleted. Please ensure that there are no related records such as other Resulting Activities. You can set the Activity to cancelled instead.`,
              life: 5000,
            })
          })
      }
    },
    openNew() {
      
      this.activity = {}
      this.activity.customer = this.opportunity.customer
      this.activity.mbpBranch = this.opportunity.mbpBranch
      this.disabledArr = [
        'customer',
        'mbpBranch'
      ]
      this.activityDialog = true;
    }
  }
};
</script>